module.exports = __webpack_public_path__ + "img/welcome.f694811a.png";